import { IEditorV3 } from "../classes/interface";

/**
 * Joins multiple EditorV3 content objects into a single content block.
 * Combines all lines from the input array and preserves the first available content properties.
 *
 * @param lines - The array of EditorV3 content objects to merge
 * @returns A single IEditorV3 object containing all combined lines
 */
export const joinV3intoBlock = (lines: IEditorV3[]): IEditorV3 => {
  const retLines = lines.flatMap((l) => l.lines);
  const retContent = lines.map((l) => l.contentProps).reduce((p, c) => p ?? c, undefined);
  return {
    lines: retLines,
    contentProps: retContent,
  };
};
